import { useEffect, useRef, useState } from 'react';
import Banner from './components/Banner';
import Carousel from './components/Carousel';
import Footer from './components/Footer';

import Header from './components/Header';
import Categories from './components/Categories';
import Contents from './components/Contents';
import SearchMenu from './components/SearchMenu';

export default function App() {
  const MENU_DATA_URL = 'https://gopronto.ca/data/';
  
  const [showHours, setShowHours] = useState(true);
  const [activeCategory, setActiveCategory] = useState(null);
  const [data, setData] = useState([]);
  const [originalData, setOriginalData] = useState([]);

  const targetCategoryPositions = [];
  
  const fetchJSON = async () => {
    await fetch(MENU_DATA_URL, {
            method: 'GET'            
          })
          .then((res) => res.json())
          .then((data) => {
            setData(data);
            setOriginalData(data);
          })
          .catch((err) => console.error('Error', err));
  }

  useEffect(() => {
    fetchJSON();
  }, [])

  const handleShowHours = () => {
    const nextShowHours = !showHours;
    setShowHours(nextShowHours);

    if (hoursRef.current) {
      hoursRef.current.classList.toggle("hidden", !nextShowHours);
    }
  }

  const hoursRef = useRef(null);

  // eslint-disable-next-line no-undef
  // console.log('showHours', showHours);
  // console.log(targetCategoryPositions);

  // console.log(data)

  return (
    <div className="w-full">       
      <Header showHours={showHours} handleShowHours={handleShowHours}/>
      <Banner ref={hoursRef} handleShowHours={handleShowHours}/>
      <Carousel />
      <Categories data={data} activeCategory={activeCategory} targetCategoryPositions={targetCategoryPositions}/>
      <SearchMenu
        originalData={originalData}
        setData={setData}
      />
      <Contents data={data} activeCategory={activeCategory} setActiveCategory={setActiveCategory} targetCategoryPositions={targetCategoryPositions} />
      <Footer />      
    </div>
    
  );
}
